import { formatTimestamp } from '../../components/formatters.ts';

/**
 * Timestamps on `/organization` fall back to the raw server string when
 * the value cannot be parsed — an unreadable date is still better than
 * an empty cell that looks like missing data.
 */
export function formatDate(raw: string): string {
  const formatted = formatTimestamp(raw);
  return formatted.length > 0 ? formatted : raw;
}
